import Banner from './banner'

export {Banner}

export default Banner
